module.exports = __webpack_public_path__ + "img/FA.76dc7c1b.png";